import React from "react";

const UploadIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.68359 20.709C5.78776 20.709 4.16797 20.0527 2.82422 18.7402C1.48047 17.4277 0.808594 15.8236 0.808594 13.9277C0.808594 12.3027 1.29818 10.8548 2.27734 9.58398C3.25651 8.31315 4.53776 7.50065 6.12109 7.14648C6.64193 5.22982 7.68359 3.67773 9.24609 2.49023C10.8086 1.30273 12.5794 0.708984 14.5586 0.708984C16.9961 0.708984 19.0638 1.55794 20.7617 3.25586C22.4596 4.95378 23.3086 7.02148 23.3086 9.45898C24.7461 9.62565 25.9388 10.2454 26.8867 11.3184C27.8346 12.3913 28.3086 13.6465 28.3086 15.084C28.3086 16.6465 27.7617 17.9746 26.668 19.0684C25.5742 20.1621 24.2461 20.709 22.6836 20.709H15.8086C15.1211 20.709 14.5326 20.4642 14.043 19.9746C13.5534 19.485 13.3086 18.8965 13.3086 18.209V11.7715L11.3086 13.709L9.55859 11.959L14.5586 6.95898L19.5586 11.959L17.8086 13.709L15.8086 11.7715V18.209H22.6836C23.5586 18.209 24.2982 17.9069 24.9023 17.3027C25.5065 16.6986 25.8086 15.959 25.8086 15.084C25.8086 14.209 25.5065 13.4694 24.9023 12.8652C24.2982 12.2611 23.5586 11.959 22.6836 11.959H20.8086V9.45898C20.8086 7.72982 20.1992 6.25586 18.9805 5.03711C17.7617 3.81836 16.2878 3.20898 14.5586 3.20898C12.8294 3.20898 11.3555 3.81836 10.1367 5.03711C8.91797 6.25586 8.30859 7.72982 8.30859 9.45898H7.68359C6.47526 9.45898 5.44401 9.88607 4.58984 10.7402C3.73568 11.5944 3.30859 12.6257 3.30859 13.834C3.30859 15.0423 3.73568 16.0736 4.58984 16.9277C5.44401 17.7819 6.47526 18.209 7.68359 18.209H10.8086V20.709H7.68359Z"
        fill={fill}
      />
    </svg>
  );
};

UploadIcon.defaultProps = {
  width: 29,
  height: 21,
  fill: "#1c1b1f",
};

export default UploadIcon;
